import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IReportingState } from './reporting.reducer';
import {
  GroupedLabelWithValue,
  LabelWithValue,
  MarketingPerformanceReportItem,
  Period,
  reportingFeatureKey,
  SalesPerformanceFacetItem,
  SalesPerformanceReportItem,
  CallsPerformanceReportItem,
} from './types';
import { createApiCallSelectors } from 'src/app/common/store/generic.selectors';

const reportingFeatureState =
  createFeatureSelector<IReportingState>(reportingFeatureKey);

export const reportingSelectors = {
  getReportByFilter: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportByFilter',
  ),
  getReportMalePeopleByAge: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportMalePeopleByAge',
  ),
  getReportFemalePeopleByAge: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportFemalePeopleByAge',
  ),
  getLeadsByDayAndHoursRange: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getLeadsByDayAndHoursRange',
  ),
  getReportPeopleByRegime: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportPeopleByRegime',
  ),
  getReportLeadsByCity: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportLeadsByCity',
  ),
  getPeriods: createApiCallSelectors<Period[], IReportingState>(
    reportingFeatureState,
    'getPeriods',
  ),
  getLeadCount: createApiCallSelectors<number, IReportingState>(
    reportingFeatureState,
    'getLeadCount',
  ),
  getConversionRateCount: createApiCallSelectors<number, IReportingState>(
    reportingFeatureState,
    'getConversionRateCount',
  ),
  getRawContractCount: createApiCallSelectors<number, IReportingState>(
    reportingFeatureState,
    'getRawContractCount',
  ),
  getValidatedContractCount: createApiCallSelectors<number, IReportingState>(
    reportingFeatureState,
    'getValidatedContractCount',
  ),
  getReportLeadsByCategory: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportLeadsByCategory',
  ),
  getReportContractsByProductCategory: createApiCallSelectors<
    any[],
    IReportingState
  >(reportingFeatureState, 'getReportContractsByProductCategory'),
  getReportLeadsBySource: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportLeadsBySource',
  ),
  getReportContractsBySource: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportContractsBySource',
  ),
  getReportLeadsBySalesPerson: createApiCallSelectors<any[], IReportingState>(
    reportingFeatureState,
    'getReportLeadsBySalesPerson',
  ),
  getReportContractsBySalesPerson: createApiCallSelectors<
    any[],
    IReportingState
  >(reportingFeatureState, 'getReportContractsBySalesPerson'),
  getReportMonthlyProgress: createApiCallSelectors<
    GroupedLabelWithValue[],
    IReportingState
  >(reportingFeatureState, 'getReportMonthlyProgress'),
  getReportSalesTotalAndObjectives: createApiCallSelectors<
    GroupedLabelWithValue[],
    IReportingState
  >(reportingFeatureState, 'getReportSalesTotalAndObjectives'),
  getSalesPerformance: createApiCallSelectors<
    SalesPerformanceReportItem[],
    IReportingState
  >(reportingFeatureState, 'getSalesPerformance'),
  getSalesPerformanceFacetItems: createApiCallSelectors<
    SalesPerformanceFacetItem[],
    IReportingState
  >(reportingFeatureState, 'getSalesPerformanceFacetItems'),
  getCallsPerformance: createApiCallSelectors<
    CallsPerformanceReportItem[],
    IReportingState
  >(reportingFeatureState, 'getCallsPerformance'),
  getMarketingPerformance: createApiCallSelectors<
    MarketingPerformanceReportItem[],
    IReportingState
  >(reportingFeatureState, 'getMarketingPerformance'),
  getBarGraphStartDate: createSelector(
    reportingFeatureState,
    (state: IReportingState) => state.barGraphStartDate,
  ),
  getBarGraphEndDate: createSelector(
    reportingFeatureState,
    (state: IReportingState) => state.barGraphEndDate,
  ),
};
